/**
 * Quake API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UpdatableRoles = 'bm_administrator' | 'bm_manager';

export const UpdatableRoles = {
    Administrator: 'bm_administrator' as UpdatableRoles,
    Manager: 'bm_manager' as UpdatableRoles
};

